import React, { useState, useEffect } from 'react';

const ImageTable = ({ images = [] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    document.body.style.overflow = modalOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [modalOpen]);

  function openModal(image) {
    setCurrent(image);
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
    setCurrent(null);
  }

  const resolveAsset = (value) => {
    if (!value) return value;
    return value && typeof value === 'object' && 'default' in value ? value.default : value;
  };

  return (
    <>
      <div className="image-table">
        {images.map((image, index) => {
          const src = typeof image === 'string' ? image : resolveAsset(image && image.src);
          const alt = typeof image === 'string' ? `Image ${index}` : (image && image.alt) || `Image ${index}`;
          const srcSet = resolveAsset(image && image.srcSet);
          const sizes = image && image.sizes;

          return (
            <div className="image-cell" key={index}>
              {src ? (
                <img
                  src={src}
                  srcSet={srcSet}
                  sizes={sizes}
                  alt={alt}
                  loading="lazy"
                  onClick={() => openModal({ src, alt, srcSet, sizes })}
                />
              ) : (
                <span>No image</span>
              )}
            </div>
          );
        })}
      </div>

      {modalOpen && current && (
        <div className="lightbox" role="dialog" onClick={closeModal}>
          <button className="lightbox-close" onClick={(e) => { e.stopPropagation(); closeModal(); }} aria-label="Close">×</button>
          <img
            className="lightbox-image"
            src={current.src}
            srcSet={current.srcSet}
            sizes={current.sizes}
            alt={current.alt}
          />
        </div>
      )}
    </>
  );
};

export default ImageTable;